import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getMaintenanceParts } from '../thunks/partsThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearPartsKey } from '../thunkKeys/partsThunksKeys';

const SLICE_NAME = 'maintenanceParts';

export const maintenancePartsSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearMaintenanceParts(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getMaintenanceParts });
        builder.addCase(clearPartsKey, () => commonInitialState);
    },
});

export const { clearMaintenanceParts } = maintenancePartsSlice.actions;

export const maintenanceParts = maintenancePartsSlice.reducer;
